import {FileItem, FileUploader, ParsedResponseHeaders} from 'ng2-file-upload';
import {ServerAddress} from '../util/server-address';

export class Uploader {


  private static onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {

    console.log(response);

  }

  private static onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {

    console.log(response);
  }

  public static getUploader():FileUploader {
    const uploader =  new FileUploader({
      url: ServerAddress.getInstance().getValue()+'upload-project-file',
      headers: [{name:'Accept', value:'application/json'}],
      autoUpload: true,
      method:'POST',
      authToken:localStorage.getItem('Authorization')

    });
    uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
    uploader.onBeforeUploadItem = (item) => {
      item.withCredentials = false;

    };

    return uploader;
  }
}
